import React from 'react';
import { formatAffiliateAmount } from '../../utils/affiliateCurrency';

/** Formatted affiliate amount (symbol shown only in card icon boxes, not here) */
const AffiliateCurrencyAmount = ({ amount, className = '' }) => (
  <span className={className} dir="ltr">
    {formatAffiliateAmount(amount)}
  </span>
);

export default AffiliateCurrencyAmount;
